import React, { Component } from 'react';
import { connect } from 'react-redux';
import Controls from './controls';

class WithFeature extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { features, featuresLoaded, featureId } = this.props;

        if (featuresLoaded == false) {
            return (
                <Controls.LoadingPanel />
            );
        }

        if (features[featureId])
            return (
                <div>
                    {this.props.children}
                </div>
            );
        else {
            return (
                <div className="jumbotron text-center">
                    <h1>Feature Unavailable</h1>
                    <p>The feature you are trying to access is not available.</p>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        features: state.core.features,
        featuresLoaded: state.core.featuresLoaded
    };
};

const WithFeaturePage = connect(mapStateToProps)(WithFeature);

const withFeature = (featureId, Component) => {
    return class FeatureContainer extends Component {
        render() {
            return (
                <WithFeaturePage featureId={featureId}>
                    <Component {...this.props} />
                </WithFeaturePage>
            );
        }
    };
}

export default withFeature;


// WEBPACK FOOTER //
// ./app/util/withFeature.js